"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostingError = void 0;
exports.unwrap = unwrap;
/** خطأ محاسبى يمنع الترحيل. يحمل كل المشاكل مرة واحدة لا أول واحدة فقط. */
class PostingError extends Error {
    issues;
    constructor(issues) {
        const summary = issues
            .map((issue) => (issue.accountCode ? issue.code + '(' + issue.accountCode + ')' : issue.code))
            .join(', ');
        super('posting rejected: ' + summary);
        this.name = 'PostingError';
        this.issues = issues;
    }
}
exports.PostingError = PostingError;
function unwrap(result) {
    if (result.ok)
        return result.value;
    throw new PostingError(result.issues);
}
//# sourceMappingURL=errors.js.map